module.exports = {"id":"dp3_1l3q5","text":"Developing digital content","instructions":"Editing content can improve accessibility for audiences.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.1","questionType":"PickOne","random":false,"options":[{"id":"dp3_1l3q5-a1","text":"True","score":3.7},{"id":"dp3_1l3q5-a2","text":"Not sure","score":1.3},{"id":"dp3_1l3q5-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l3q5.json
// module id = 1119
// module chunks = 41